export enum LabelsNamespaces {
	Accessibility = 'Accessibility',
	Apps = 'Apps',
	ATC_Form = 'ATC_form',
	Brands = 'Brands',
	Campaigns_Promotions = 'Campaigns_Promotions',
	Chat_AI = 'Chat_AI',
	Checkout = 'Checkout',
	Client = 'Client',
	Cookies = 'Cookies',
	Discover = 'Discover_by_Mango',
	Edit_Test_Keys_SS25 = 'Edit_Woman_Capsule_SS25',
	Edit_Kids_BTS_2025 = 'Edit_Kids_BTS_2025',
	Edit_Kids_AltoInvierno_2025 = 'Edit_FW25_Kids_AltoInvierno',
	Edit_LandingSostenibilidad = '2025_LandingSostenibilidad',
	Edit_Man_Essentials_FW25 = 'Edit_Man_Essentials_CasperRuud_Sept25',
	Edit_Woman_Kaia_SS25 = 'Edit_Woman_Kaia_Capsule_SS25',
	Edit_Woman_MangoBox_FW25 = 'Edit_Woman_MangoBox_AW25',
	Edit_Woman_Materra_FW25 = 'edit.materra.ss25',
	Edit_Woman_PartyWoman_FW25 = 'Edit_Woman_KaiaParty_Oct25',
	Edit_Woman_Selection_FW25 = 'Edit_W_Selection_Sep25',
	Edit_Man_Selection_FW25 = 'Edit_Man_Selection_Oct25',
	Edit_Home_Navidad_FW25 = 'Edit_Home_Navidad_Nov25',
	Filters = 'Filters',
	Footer = 'Footer',
	Forms = 'Forms',
	Generic_Editorial_Translations = 'Generic_Editorial_Translations',
	Gift_Voucher = 'Gift_card',
	Header = 'Header',
	Homes_Outlet = 'Homes_Outlet',
	Genesis_Edits_Video = 'Genesis_Edits_Video',
	Homes_Shop = 'Homes_Shop',
	Landing_Discover_2025 = 'Landing Discover 2025',
	Landing_Mango_Likes_You = 'Landing_Mango_Likes_You',
	Landing_Mango_Style_Club = 'Landing_Mango_Style_Club',
	Legal = 'Legal_texts',
	Loyalty = 'Loyalty',
	Mango_Style_Club = 'Mango_Style_Club',
	Menu_Common = 'Menu_Common_Keys',
	Menu_Outlet = 'Menu_outlet',
	Menu_Shop = 'Menu_shop',
	Modal_conditions_PDP = 'Modal_conditions_PDP',
	MLY_Club_Mango_Likes_You = 'Club_Mango_Likes_You',
	MLY_PartnersONG = 'MLY_PartnersONG',
	My_Addresses = 'My_addresses',
	My_Details = 'My_details',
	My_profile = 'My_profile',
	My_purchases = 'My_purchases',
	Navigation = 'Navigation',
	Notify_me = 'Notify_me',
	Payment_Checkout = 'Payment_Checkout',
	Payment_Form = 'Payment_Form',
	Performance = 'Performance',
	Perseo_Metas_H1_Outlet_Homes = 'Perseo_Metas_H1_Outlet_Homes',
	Perseo_Metas_H1_Shop_Homes = 'Perseo_Metas_H1_Shop_Homes',
	Prehome_Country_Selector = 'Prehome_Country_Selector',
	Prices = 'Prices',
	Product_Card = 'Product_card',
	Promos_Alerts_Checkout = 'Promos_Alerts_Checkout',
	Promotions_Outlet = 'Outlet_Promotions',
	Promotions_Shop = 'Promotions_Shop',
	Pdp = 'PDP',
	Plp = 'PLP',
	Plp_Pdp = 'Plp_Pdp',
	Purchase_confirmation = 'Purchase_confirmation',
	Returns_and_refunds = 'Returns_and_refunds',
	Search_Bar = 'Search_Bar',
	Shopping_Bag = 'Shopping_Bag',
	Shopping_Bag_Checkout = 'Shopping_Bag_Checkout',
	Signin_Create_account = 'Signin_Create_account',
	Size_Guide = 'Size_Guide',
	Store_Locator = 'Store_locator',
	Subscribe_Newsletter = 'Subscribe_Newsletter',
	Transversal_Keys = 'Transversal_Keys',
	USA_privacy_form = 'USA_privacy_form',
	Wishlist = 'Wishlist',
	Backoffice = 'Backoffice',
	Backoffice_Content_Invalidator = 'Backoffice_Content_Invalidator',
	Backoffice_Bart = 'Backoffice_Bart',
	Backoffice_Garment_Sorter = 'Backoffice_Garment_Sorter',
	Backoffice_Juice = 'Backoffice_Juice',
	Backoffice_Labels = 'Backoffice_Labels',
	Backoffice_Mambo = 'Backoffice_Mambo',
	Backoffice_Navigation = 'Backoffice_Navigation',
	Backoffice_Payments_Post_Sale = 'Backoffice_Payments_Post_Sale',
	Backoffice_Physical_Store = 'Backoffice_Physical_Store',
	Backoffice_Product_Color_Group = 'Backoffice_Product_Color_Group',
	Backoffice_Product_Enable_Selling = 'Backoffice_Product_Enable_Selling',
	Backoffice_Product_Families = 'Backoffice_Product_Families',
	Backoffice_Product_Promo_Sales = 'Backoffice_Product_Promo_Sales',
	Backoffice_Product_Promotions_Messages = 'Backoffice_Product_Promotions_Messages',
	Backoffice_Product_Shared = 'Backoffice_Product_Shared',
	Backoffice_Product_Sheet = 'Backoffice_Product_Sheet',
	Backoffice_Product_Tags = 'Backoffice_Product_Tags',
	Backoffice_Product_Total_Look = 'Backoffice_Product_Total_Look',
	Backoffice_Product_Ungroup = 'Backoffice_Product_Ungroup',
	Backoffice_Promo_Codes = 'Backoffice_Promo_Codes',
	Backoffice_Sales_Statistics = 'Backoffice_Sales_Statistics',
	Backoffice_Product_Publishing = 'Backoffice_Product_Publishing',
	Backoffice_Seo = 'Backoffice_Seo',
	Backoffice_Shared = 'Backoffice_Shared',
	Backoffice_Families = 'Backoffice_Families',
	Help_Chatbot = 'UX_Help_Chatbot',
	Sitemap = 'Perseo_Sitemap',
	Backoffice_Menu_Manager = 'Backoffice_Menu_Manager',
	My_Payments = 'My_payments',
	MSC_Benefits = 'MSC_Benefits',
	Video_Player = 'Video_Player',
}

export type Plurals = Partial<Record<Intl.LDMLPluralRule, string>>
export type Labels<T extends string = string> = Record<T, string | Plurals>
